import axios from "axios";
import { useTranslation } from "react-i18next";
import { useRefresh } from "../../../../utils/RefreshProvider";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import Notify from "../../../../utils/useNotify";

export default function AddElement({ isItSize }) {
  const { t } = useTranslation();
  const { triggerRefresh } = useRefresh();
  const token = localStorage.getItem('token');
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [isOpen, setIsOpen] = useState(false);

  function closeModal() { setIsOpen(false) }
  function openModal() { setIsOpen(true) }

  // Category :
  const [titleEn, setTitleEn] = useState('');
  const [titleFr, setTitleFr] = useState('');
  const [detailsEn, setDetailsEn] = useState('');
  const [detailsFr, setDetailsFr] = useState('');
  const link = isItSize ? 'admin/sizes' : 'admin/categories';
  const type = isItSize ? 'size' : 'category';

  const handleAdd = (e) => {
    const categoryData = isItSize ? { name: titleEn, description: { en: detailsEn, fr: detailsFr } }
      : { name: { en: titleEn, fr: titleFr }, description: { en: detailsEn, fr: detailsFr } };

    axios.post(localhost + link, categoryData, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        Notify('success', t('add-' + type + '-success'));
        triggerRefresh();
        setIsOpen(false);
        setTitleEn('');
        setTitleFr('');
        setDetailsEn('');
        setDetailsFr('');
      })
      .catch((err) => {
        Notify('error', t('add-' + type + '-error'));
        console.error(err);
      });
  };

  return (
    <>
      <button onClick={openModal} className="flex flex-wrap gap-1 items-center text-sm bg-black hover:bg-black/80 text-white pl-2 pr-3 py-2 max-sm:p-1.5 rounded-md">
        <PlusIcon className="h-[18px] w-[18px]" />
        <span className="max-sm:hidden">{t('add-' + type)}</span>
      </button>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div>
                    <div className='grid grid-cols-2 gap-2 mb-3'>
                      <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-1 text-sm font-medium text-black">Title <span className={`text-orange-500 text-xs ${isItSize ? 'hidden' : ''}`}>({t("english")})</span></label>
                        <input type="text" value={titleEn} onChange={(e) => setTitleEn(e.target.value)}
                          className="focus:ring-orange-600 focus:border-orange-600 placeholder:lowercase bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5" placeholder="Title" required />
                      </div>
                      <div className={`col-span-2 ${isItSize ? 'hidden' : ''}`}>
                        <label className="flex flex-wrap items-center gap-1 mb-1 text-sm font-medium text-black">Titre <span className='text-orange-500 text-xs'>({t("french")})</span></label>
                        <input type="text" value={titleFr} onChange={(e) => setTitleFr(e.target.value)}
                          className="focus:ring-orange-600 focus:border-orange-600 placeholder:lowercase bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5" placeholder="Titre" required />
                      </div>
                    </div>

                    <div className='grid grid-cols-2 gap-2 mb-2'>
                      <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-1 text-sm font-medium text-black">Description <span className='text-orange-500 text-xs'>({t("english")})</span></label>
                        <textarea rows="4" value={detailsEn} onChange={(e) => setDetailsEn(e.target.value)}
                          className="focus:ring-orange-600 focus:border-orange-600 placeholder:lowercase bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5" placeholder="description..." />
                      </div>
                      <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-1 text-sm font-medium text-black">Description <span className='text-orange-500 text-xs'>({t("french")})</span></label>
                        <textarea rows="4" value={detailsFr} onChange={(e) => setDetailsFr(e.target.value)}
                          className="focus:ring-orange-600 focus:border-orange-600 placeholder:lowercase bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5" placeholder="description..." />
                      </div>
                    </div>

                    <div className="w-full flex justify-end items-center gap-2">
                      <button onClick={handleAdd} className='py-2 px-4 bg-black hover:bg-black/80 text-white rounded-md text-sm'>{t("create")}</button>
                      <button type="button" className='border py-2 px-4 bg-white hover:bg-gray-100 hover:text-black/80 text-black rounded-md text-sm' onClick={() => setIsOpen(false)}>{t("cancel")}</button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
